<template>
	<!-- 弹窗 -->
	<el-dialog :title="setTitle" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
		<div v-if="mode=='muban'">
			<div class="mubanDown" v-for="(item,index) in downloadList.list" :key="index">
				<p>{{index+1}}：{{item.name | titleFilter}}</p>
				<a :href="item.path" target="_blank" download><button type="button">点击下载</button></a>
			</div>
		</div>

		<div class="innerdialog_list" v-if="mode=='upload'">
			<p class="listP">选择模板：</p>
			<div class="list_center">
				<div class="inner_upload" v-for="(item,index) in fileList" :key="index">
					<p>{{item.name}}</p>
					<img src="../../../assets/img/login/cuowu.png" @click="deleteUpload(index)">
				</div>
			</div>
			<el-upload ref="upload" style="display: inline-block;" action="" :http-request="httpRequest"
				:on-remove="handleRemove" :accept="acceptList" :before-upload="beforeUpload" :file-list="fileList"
				:show-file-list="false">
				<span class="specilSpan">···</span>
			</el-upload>
		</div>
		<div v-if="mode=='upload'"><small>单个照片大小限制10M以内；单个文件大小限制50M以内</small></div>

		<!-- 保存提示 -->
		<div class="tipList" v-if="mode=='tips'">
			<p>经推荐单位推荐，我单位确认申报本次项目，郑重承诺如下：</p>
			<p>一、我单位提交的资料齐全、真实、有效、不存在弄虚作假的现象</p>
			<p>
				二、我单位在参评过程中，坚决遵守相关规定，杜绝向评审有关人员发出宴请，赠送礼品、纪念品、现金、
				有价证券、支付凭证等，不组织旅游和与评选工作无关的参观活动。若有违背上述承诺，我单位愿意承担相应责任，
				按规定接受处罚，自愿放弃参评资格或取消荣誉称号。</p>
		</div>

		<!-- 模板下载 -->
		<span slot="footer" class="dialog-footer" v-if="mode=='muban'">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
		</span>

		<!-- 上传 -->
		<span slot="footer" class="dialog-footer" v-if="mode=='upload'">
			<el-button @click="dialogVisible = false">返回</el-button>
			<el-button type="primary" @click="sureUpload">确认上传</el-button>
			<!--	<el-button type="primary" @click="sureSubmit">保存</el-button>-->
		</span>

		<!--  -->
		<span slot="footer" class="dialog-footer" v-if="mode=='tips'">
			<el-button @click="dialogVisible = false">返回</el-button>
			<el-button type="primary" @click="showScore">确认提交</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import {
		sureSubmit,
		getUploadFile

	} from '../../../api/moudles/manager.js'
	import {
		client
	} from '@/libs/oss.js'
	export default {
		data() {
			return {
				submitType: '',
				mode: 'muban',
				dialogVisible: false,
				// 模板下载数据
				downloadList: [],
				uploadList: [],
				fileList: [],
				project_app_num: '',
				acceptList: ''
			}
		},
		computed: {
			setTitle() {
				if (this.mode === 'muban') {
					return '模板下载'
				} else if (this.mode === 'tips') {
					return '承诺和说明'
				} else {
					return '文件上传'
				}
			}
		},
		components: {},
		filters: {
			titleFilter(value) {
				if (value.length > 18) {
					const newVluae = value.split('.')[0].slice(0, 15) + '···.' + value.split('.')[1]
					return newVluae
				}
				return value
			}
		},
		methods: {
			//保存
			async sureSubmit() {
				let item = this.fileList[0]
				let dataUpload = sessionStorage.getItem('dataUpload')
				let dataJson = []
				let data = {}
				data['data_name'] = item.name ? item.name : item.data_name
				data['type'] = parseInt(dataUpload) + 1
				data['stored_path'] = item.url ? item.url : item.stored_path
				dataJson.push(data)
				let Project_app_num
				Project_app_num = this.project_app_num
				const params = {
					dataJson: dataJson,
					project_app_num: Project_app_num
				}
				await getUploadFile({
					data: params,
					success: res => {
						// console.log(res)
						if (res.code === 200) {
							/*this.$message({
								message:  '保存成功',
								type: 'success'
							});*/
							this.allSubmit = true
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			// 确认提交
			async showScore() {
				let Project_app_num
				Project_app_num = this.project_app_num
				const params = {
					project_app_num: Project_app_num,
					submitType: this.submitType
				}
				await sureSubmit({
					data: params,
					success: res => {
						if (res.code === 200) {
							this.$message({
								message: res.msg,
								type: 'success'
							});
							this.dialogVisible = false
							this.$emit('refresh',true)
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			//确认上传
			sureUpload() {
				if (!this.fileList.length) {
					this.dialogVisible = false
					return
				}
				this.sureSubmit()
				this.$message({
					message: '添加成功',
					type: 'success'
				});
				this.$emit('submitSuccess', this.fileList)
				this.dialogVisible = false
				setTimeout(() => {
					this.fileList = []
				})
			},
			// 移除
			handleRemove(e, fileList) {
				this.fileList = fileList;
			},
			//上传前
			beforeUpload(file) {
				let isLt2M
				if (file.type.indexOf('image') != -1) {
					isLt2M = file.size / 1024 / 1024 < 10;
					if (!isLt2M) {
						this.$message.error('图片大小不能超过 10M !');
					}
				} else {
					isLt2M = file.size / 1024 / 1024 < 50;
					if (!isLt2M) {
						this.$message.error('文件大小不能超过 50M !');
					}
				}
				return isLt2M;
			},
			httpRequest({
				file
			}) {
				const fileName = `项目申报/${Date.parse(new Date())}/${file.name}`; //定义唯一的文件名
				client.put(fileName, file).then(({
					res,
					url,
					name
				}) => {
					if (res && res.status == 200) {
						/*this.$message({
							message: '上传成功',
							type: 'success'
						});*/
						// console.log(`阿里云OSS上传文件成功回调`, res, url, name);
						this.fileList.push({ //回显文件name用
							url: url,
							id: fileName,
							name: file.name,
						})
					}
				}).catch((err) => {
					console.log(`阿里云OSS上传失败回调`, err);
				});
			},
			showAdd(params) {
				this.dialogVisible = true
				if (params.status) {
					this.submitType = params.status
				}
				this.mode = params.type
				if (params.project) {
					this.acceptList = '.pdf'
				} else {
					this.acceptList = ''
				}
				this.project_app_num = params.project_app_num
				if (params.type === 'muban') {
					this.$set(this.downloadList, 'list', params.download)
				}
			},
			handleClose() {
				this.dialogVisible = false
			},
			// 删除上传数据
			deleteUpload(index) {
				this.fileList.splice(index, 1)
			}
		}
	}
</script>

<style scoped="scoped">
	.el-dialog__header {
		height: 100px;
		line-height: 100px;
	}

	.el-dialog__body {
		padding: 10px 20px;
	}

	>>>.el-dialog {
		border-radius: 6px;
	}

	/* 模板下载 */
	.mubanDown {
		display: flex;
		height: 40px;
		line-height: 40px;
		justify-content: space-between;
		align-items: center;
	}

	.mubanDown button {
		cursor: pointer;
		width: 80px;
		height: 35px;
		line-height: 35px;
		border: 1px solid #1890FF;
		font-size: 12px;
		background-color: #ffffff;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #1890FF;
	}

	.innerdialog_list {
		padding-top: 20px;
		display: flex;
		/* height: 40px; */
		align-items: flex-start;
		line-height: 40px;
		align-content: flex-start;
		margin-bottom: 10px;
		border-bottom: 1px solid #B5B5B5;
	}

	/* .innerdialog_list p {
		
	} */
	.listP {
		font-size: 14px;
		width: 80px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
	}

	.innerdialog_list span {
		display: block;
		font-size: 12px;
		width: 40px;
		margin-left: 20px;
		height: 20px;
		line-height: 20px;
		background: #FFFFFF;
		text-align: center;
		border: 1px solid #1890FF;
		cursor: pointer;
	}

	.list_center {
		width: 310px;
		min-height: 40px;
		display: flex;
		align-content: flex-start;
		flex-wrap: wrap;
	}

	/* 每个上传文件的样式 */
	.inner_upload {
		position: relative;
		min-height: 40px;
		margin: 0 10px;
		/* width: 100px; */
		/* overflow: scroll; */
	}

	.inner_upload p {
		color: #1890FF;
	}

	.inner_upload img {
		border-radius: 50%;
		position: absolute;
		right: 0;
		top: 0;
		width: 15px;
		height: 15px;
		cursor: pointer;
	}

	/* 保存提示 */
	.tipList p {
		line-height: 25px;
		text-align: left;
	}

	.tipList p:first-child {
		margin-bottom: 20px;
	}
</style>
